import { render, staticRenderFns } from "./RejeitadaSelo.vue?vue&type=template&id=4f20f450&scoped=true"
import script from "./RejeitadaSelo.vue?vue&type=script&lang=js"
export * from "./RejeitadaSelo.vue?vue&type=script&lang=js"
import style0 from "./RejeitadaSelo.vue?vue&type=style&index=0&id=4f20f450&prod&lang=css"
import style1 from "./RejeitadaSelo.vue?vue&type=style&index=1&id=4f20f450&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f20f450",
  null
  
)

export default component.exports